<div class="header-background">
  @if (navigationService.backButton$ | async) {
    <button backButton [backPath]="backPath" mat-icon-button>
      <mat-icon>west</mat-icon>
    </button>
  }

  @if (provider?.header && !useWhiteLabel) {
    <div class="logo-lad" [class.no-pointer]="isShortFlow || isAppointmentShortFlow" (click)="goToHome()">
      @if (mobileQuery.matches) {
        <mat-icon svgIcon="isotype-lad"></mat-icon>
      }
      @if (!mobileQuery.matches) {
        <app-logo></app-logo>
      }
    </div>
  }

  @if (provider) {
    <div class="logo" [ngClass]="{ header: provider.header, 'no-pointer': isShortFlow || isAppointmentShortFlow }" (click)="goToHome()">
      @if (provider.header) {
        <img [src]="provider.header" />
      } @else {
        <app-logo [providerTitle]="providerTitle"></app-logo>
      }
    </div>
  }

  @if (navigationService.options$ | async) {
    <div class="options">
      <a mat-icon-button [href]="faqURL" target="_blank">
        <mat-icon svgIcon="questions"></mat-icon>
      </a>
      @if (showSetting) {
        <button (click)="showEvent()" mat-icon-button routerLink="{{ '/' + settingsPath }}" routerLinkActive="active">
          <mat-icon svgIcon="settings"></mat-icon>
        </button>
      }
    </div>
  }
</div>
